$(document).on('shopify:section:load', function() {
    
    if (typeof compare !== 'undefined') {
        getCompare();
    }

    if (typeof featured !== 'undefined') {
        featured.forEach(function(id, index) {
            $(`.models[data-models="${index+1}"] .model[data-model="${id}"]`).trigger('click');
        });
    }

    let isSyncingScroll = false;

    function syncScroll(source) {
        if (isSyncingScroll) return;
        isSyncingScroll = true;

        const scrollLeft = source.scrollLeft();

        $('.product-comparison .hozscroll, .product-comparison .selection, .product-comparison .accordion-body, .product-comparison .hidden-scroll').not(source).each(function() {
            $(this).scrollLeft(scrollLeft);
        });

        isSyncingScroll = false;
    }

    $('.product-comparison .hozscroll, .product-comparison .selection, .product-comparison .accordion-body, .product-comparison .hidden-scroll').on('scroll', function() {
        syncScroll($(this));
    });
    
});

$(document).ready(function() {
    
    if (typeof compare !== 'undefined') {
        getCompare();
    }

    if (typeof featured !== 'undefined') {
        featured.forEach(function(id, index) {
            $(`.models[data-models="${index+1}"] .model[data-model="${id}"]`).trigger('click');
        });
    }

    let isSyncingScroll = false;

    function syncScroll(source) {
        if (isSyncingScroll) return;
        isSyncingScroll = true;

        const scrollLeft = source.scrollLeft();

        $('.product-comparison .hozscroll, .product-comparison .selection, .product-comparison .accordion-body, .product-comparison .hidden-scroll').not(source).each(function() {
            $(this).scrollLeft(scrollLeft);
        });

        isSyncingScroll = false;
    }

    $('.product-comparison .hozscroll, .product-comparison .selection, .product-comparison .accordion-body, .product-comparison .hidden-scroll').on('scroll', function() {
        syncScroll($(this));
    });
    
});

function getCompare() {

    $('.compare .data').html('');
    $('.compare .data--product img').attr('src', '');
    $('.compare .data--product a').attr('href', '');
    $('.compare .data--product .product-title').html('');
    $('.compare .data--product .product-price').html('');
    $('.compare .data--product .product-compare-price').html('');
    
    $('.compare .data--product .klarna-placeholder').html('');

    $(`.compare .data--product`).css('display', 'none');
    $(`.compare .data--placeholder`).css('display', 'flex');

    $('.selection .btn-select div').html('Select');

    let idx = 0;
    compare.forEach(product => {

        let klarna =    `<klarna-placement
                            data-key="credit-promotion-badge"
                            data-locale="en-US"
                            data-purchase-amount="${product.klarna}"
                        ></klarna-placement>`

        $(`.selection .btn-select:eq(${idx})`).attr('data-selected', product.id);
        $(`.selection .btn-select:eq(${idx}) div`).html(product.title);

        $(`.compare .data--product:eq(${idx})`).css('display', 'flex');
        $(`.compare .data--placeholder:eq(${idx})`).css('display', 'none');

        $(`.compare .data--product:eq(${idx}) img`).attr('src', product.featured_image);
        $(`.compare .data--product:eq(${idx}) .product-title`).html(product.title);
        $(`.compare .data--product:eq(${idx}) .product-price`).html(product.price);
        $(`.compare .data--product:eq(${idx}) .product-compare-price`).html(product.compare_price);
        $(`.compare .data--product:eq(${idx}) a`).attr('href', product.url);

        $(`.compare .data--product:eq(${idx}) .klarna-placeholder`).html(klarna);

        $(`.compare .data--brightness:eq(${idx})`).html(product.brightness);
        $(`.compare .data--image_size:eq(${idx})`).html(product.image_size);
        $(`.compare .data--resolution:eq(${idx})`).html(product.resolution);
        $(`.compare .data--light_source:eq(${idx})`).html(product.light_source);
        $(`.compare .data--contrast_ratio:eq(${idx})`).html(product.contrast_ratio);
        $(`.compare .data--projection_type:eq(${idx})`).html(product.projection_type);
        $(`.compare .data--connectivity:eq(${idx})`).html(product.connectivity);
        $(`.compare .data--throw_ratio:eq(${idx})`).html(product.throw_ratio);
        $(`.compare .data--display_tech:eq(${idx})`).html(product.display_tech);
        $(`.compare .data--hdr:eq(${idx})`).html(product.hdr);
        $(`.compare .data--power_consumption:eq(${idx})`).html(product.power_consumption);
        $(`.compare .data--os:eq(${idx})`).html(product.os);
        $(`.compare .data--smart_features:eq(${idx})`).html(product.smart_features);
        $(`.compare .data--dimensions:eq(${idx})`).html(product.dimensions);
        $(`.compare .data--speaker:eq(${idx})`).html(product.speaker);
        $(`.compare .data--weight:eq(${idx})`).html(product.weight);
        $(`.compare .data--wifi:eq(${idx})`).html(product.wifi);
        $(`.compare .data--bluetooth:eq(${idx})`).html(product.bluetooth);
        $(`.compare .data--noise_level:eq(${idx})`).html(product.noise_level);
        $(`.compare .data--ram:eq(${idx})`).html(product.ram);
        $(`.compare .data--rom:eq(${idx})`).html(product.rom);

        idx++;

        $(`.models[data-models="${idx}"] .model[data-model="${product.id}"]`).addClass('active');
    });
}

let hideTimeout;

$('.btn-select').hover(function(){
    let model = $(this).data('selection');

    $('.models').hide();

    if ($(window).outerWidth() >= 1280) {
        let btnRight = $(this).position().left + $(this).outerWidth();
        let modelsWidth = $('.models').outerWidth();
        let modelsLeft = btnRight - modelsWidth;

        $(`.models[data-models="${model}"]`).css('left', modelsLeft);
        $(`.models[data-models="${model}"]`).show();
    }
    else if ($(window).outerWidth() >= 768) {
        $(`.models[data-models="${model}"]`).css('left', '20px');
        $(`.models[data-models="${model}"]`).show();
    }
    else {
        $(`.models[data-models="${model}"]`).css('left', '20px');
        $(`.models[data-models="${model}"]`).show();
    }
});

$('.selection, .models').mouseenter(function(){
    if ($('.models[data-models="1"]').is(':visible')) {
        $('.models[data-models="1"]').show();
    }
    if ($('.models[data-models="2"]').is(':visible')) {
        $('.models[data-models="2"]').show();
    }
    if ($('.models[data-models="3"]').is(':visible')) {
        $('.models[data-models="3"]').show();
    }
}).mouseleave(function(){
    if (!$('.models[data-models="1"]').is(':hover')) {
        $('.models[data-models="1"]').hide();
    }
    if (!$('.models[data-models="2"]').is(':hover')) {
        $('.models[data-models="2"]').hide();
    }
    if (!$('.models[data-models="3"]').is(':hover')) {
        $('.models[data-models="3"]').hide();
    }
});

$('.models .model').on('click', function() {
    const $parent = $(this).closest('.models');
    $parent.find('.model').removeClass('active');
    $(this).addClass('active');

    let index = $(this).parents('.models').data('models');

    let modelId = $(this).data('model');
    let matchingProduct = compare_products.find(function(product) {
        return product.id == modelId;
    });

    if (matchingProduct) {
        compare[index] = matchingProduct;
    }

    console.log(compare);

    getCompare();
});